// extracted by mini-css-extract-plugin
export default {"speedWrapper":"ceLK1"};